import {useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from 'common/button'
import {Text} from 'common/text'
import {DISPLAY_NAME_MENU} from 'const/display_name_menu'
import {
  MONTHLY_REVIEW_CONTENT_MAX_LENGTH,
  MONTHLY_REVIEW_MAX_STAR,
} from './_constants'
import {MONTHLY_REVIEW_ICONS} from './_icons'
import {StyledMonthlyReviewModal} from './_styled'

const STAR_LIST = Array.from(
  {length: MONTHLY_REVIEW_MAX_STAR},
  (_, i) => i + 1,
)

export const MonthlyReviewModal = ({
  content,
  loading,
  month,
  star,
  onChangeContent,
  onChangeStar,
  onClose,
  onSkip,
  onSubmit,
  ...props
}) => {
  const {t} = useTranslation()
  const [hoverStar, setHoverStar] = useState(0)
  const mouseDownOnOverlay = useRef(false)

  const activeStar = hoverStar || star

  const handleOverlayMouseDown = e => {
    mouseDownOnOverlay.current = e.target === e.currentTarget
  }

  const handleOverlayClick = e => {
    if (e.target !== e.currentTarget || !mouseDownOnOverlay.current) return
    onClose()
  }

  return (
    <StyledMonthlyReviewModal
      onClick={handleOverlayClick}
      onMouseDown={handleOverlayMouseDown}
      {...props}
    >
      <div className="monthly-review__container">
        <i className="monthly-review__close" onClick={onClose}>
          {MONTHLY_REVIEW_ICONS.close}
        </i>

        <div className="monthly-review__header">
          <Text
            as="h2"
            className="monthly-review__title"
            fontSize={24}
            fontWeight={600}
            lineHeight={34}
            style={{width: '100%'}}
          >
            {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.TITLE, {month})}
          </Text>
          <Text
            as="p"
            className="monthly-review__subtitle"
            color="#00081D"
            fontSize={12}
            lineHeight={17}
            style={{width: '100%'}}
          >
            {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.SUBTITLE)}
          </Text>

          <div
            className="monthly-review__stars"
            onMouseLeave={() => setHoverStar(0)}
          >
            {STAR_LIST.map(item => (
              <button
                key={item}
                type="button"
                className="monthly-review__star"
                data-active={item <= activeStar}
                onClick={() => onChangeStar(item)}
                onMouseEnter={() => setHoverStar(item)}
              >
                {MONTHLY_REVIEW_ICONS.star}
              </button>
            ))}
          </div>
        </div>

        <div className="monthly-review__body">
          <Text className="monthly-review__label">
            {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.FEEDBACK_LABEL)}
          </Text>
          <textarea
            className="monthly-review__textarea"
            maxLength={MONTHLY_REVIEW_CONTENT_MAX_LENGTH}
            placeholder={t(
              DISPLAY_NAME_MENU.MONTHLY_REVIEW.FEEDBACK_PLACEHOLDER,
            )}
            value={content}
            onChange={onChangeContent}
          />
        </div>

        <div className="monthly-review__footer">
          <Button appearance="ghost" disabled={loading} onClick={onSkip}>
            {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.SKIP)}
          </Button>
          <Button disabled={loading} onClick={onSubmit}>
            {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.SUBMIT)}
          </Button>
        </div>
      </div>
    </StyledMonthlyReviewModal>
  )
}
